export enum DomainType {
    DOMAIN = 'DOMAIN',
    FILESERVER = 'FILE_SERVER'
}
